import { render, staticRenderFns } from "./my-assets.vue?vue&type=template&id=1ac9e593&scoped=true&"
import script from "./my-assets.vue?vue&type=script&lang=js&"
export * from "./my-assets.vue?vue&type=script&lang=js&"
import style0 from "./my-assets.vue?vue&type=style&index=0&id=1ac9e593&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9e593",
  null
  
)

export default component.exports